export default "__VITE_ASSET__Bl8ykL8D__"